import { z } from 'zod';
// The desired execution timeframe captured at offer-request intake.
export const offerRequestTimeConstraintSchema = z.enum([
    'IMMEDIATELY',
    'AS_SOON_AS_POSSIBLE',
    'WITHIN_2_WEEKS',
    'WITHIN_30_DAYS',
    'OVER_TWO_WEEKS',
    'WITHIN_1_MONTH',
    'WITHIN_3_MONTHS',
    'WITHIN_6_MONTHS',
    'WITHIN_9_MONTHS',
    'WITHIN_12_MONTHS',
    'IN_3_TO_6_MONTHS',
    'EARLIEST_IN_6_MONTHS',
    'ONE_WEEK',
    'TWO_WEEKS',
    'THREE_WEEKS',
    'FOUR_WEEKS',
    'LONGER_THAN_4_WEEKS',
    'BY_ARRANGEMENT',
    'UNKNOWN',
]);
export const OfferRequestTimeConstraint = offerRequestTimeConstraintSchema.enum;
